import type { UserDetails } from '@apiTypes'
import type { PermissionObject, PermissionType } from '@/types/permissions'
import { permissionObjectPrefix } from '@/types/permissions'

export function userHasPermissions(user: UserDetails | null, object: PermissionObject, type: PermissionType): boolean {
  const permissionString = `${permissionObjectPrefix[object]}.${type}_${object}`

  return (user?.permissions || []).includes(permissionString)
}
